/**
 * Extracts the prefix (local part) of an email address before the "@" symbol.
 *
 * @param email - The full email address to process.
 * @returns The local part of the email address before "@".
 * @throws Will throw an error if the email does not contain an "@" symbol.
 */
export function extractEmailPrefix(email: string): string {
  const atIndex = email.indexOf('@');
  if (atIndex === -1) {
    throw new Error("Invalid email: missing '@' symbol");
  }

  return email.substring(0, atIndex);
}

/**
 * Returns a two-letter abbreviation made from the capitalized
 * first and last characters of the input string.
 *
 * @param s - The input string to abbreviate. Must not be empty.
 * @returns A string consisting of the first and last letters in uppercase.
 * @throws Error if the input string is empty.
 */
export function abbreviateByEnds(s: string): string {
  if (!s) throw new Error('Invalid string: must not be empty');

  const first = s[0].toUpperCase();
  const last = s[s.length - 1].toUpperCase();

  return first + last;
}
